import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Chip,
  Button,
} from '@mui/material';
import {
  Refresh,
  Logout,
  AccountCircle,
} from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';

interface HeaderProps {
  onRefresh: () => void;
  isLoading: boolean;
}

const Header: React.FC<HeaderProps> = ({ onRefresh, isLoading }) => {
  const { user, logout } = useAuth();

  const handleLogout = () => {
    if (window.confirm('Çıkış yapmak istediğinizden emin misiniz?')) {
      logout();
    }
  };

  return (
    <AppBar 
      position="static" 
      sx={{ 
        background: 'linear-gradient(90deg, #667eea 0%, #764ba2 100%)',
        boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
      }}
    >
      <Toolbar>
        <Typography 
          variant="h5" 
          component="div" 
          sx={{ 
            flexGrow: 1, 
            fontWeight: 'bold',
            textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
          }}
        >
          🤖 Bot Yönetim Paneli
        </Typography>
        
        {/* User Info */}
        <Box display="flex" alignItems="center" gap={2} mr={2}>
          <Chip
            icon={<AccountCircle />}
            label={`👋 ${user?.username}`}
            sx={{
              background: 'rgba(255,255,255,0.9)',
              color: '#667eea',
              fontWeight: 'bold',
              '& .MuiChip-icon': {
                color: '#667eea',
              }
            }}
          />
          
          <Typography 
            variant="body2" 
            sx={{ 
              color: 'rgba(255,255,255,0.9)',
              display: { xs: 'none', sm: 'block' }
            }}
          >
            🔐 Admin
          </Typography>
        </Box>

        {/* Action Buttons */}
        <Box display="flex" alignItems="center" gap={1}>
          <IconButton
            color="inherit"
            onClick={onRefresh}
            disabled={isLoading}
            title="Yenile"
            sx={{
              background: 'rgba(255,255,255,0.2)',
              '&:hover': {
                background: 'rgba(255,255,255,0.3)',
                transform: 'scale(1.1)'
              },
              transition: 'all 0.3s ease'
            }}
          >
            <Refresh />
          </IconButton>
          
          <Button
            color="inherit"
            onClick={handleLogout}
            startIcon={<Logout />}
            sx={{
              background: 'rgba(255,255,255,0.1)',
              borderRadius: '12px',
              fontWeight: 'bold',
              textTransform: 'none',
              border: '1px solid rgba(255,255,255,0.3)',
              '&:hover': {
                background: 'rgba(255,255,255,0.2)',
                transform: 'scale(1.05)',
              },
              transition: 'all 0.3s ease',
              display: { xs: 'none', sm: 'flex' }
            }}
          >
            Çıkış
          </Button>
          
          {/* Mobile logout button */}
          <IconButton
            color="inherit"
            onClick={handleLogout}
            title="Çıkış Yap"
            sx={{
              background: 'rgba(255,255,255,0.2)',
              '&:hover': {
                background: 'rgba(255,255,255,0.3)',
                transform: 'scale(1.1)'
              },
              transition: 'all 0.3s ease',
              display: { xs: 'flex', sm: 'none' }
            }}
          >
            <Logout />
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
